"use client";

import { Box, Stack, Typography } from "@mui/material";
import color from "@/style/theme/Color";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Link from "next/link";

const menus = [
  {
    title: "Fasilitas",
    path: null,
    submenus: [
      {
        title: "Meja Baca",
        path: "/baca"
      },
      {
        title: "Koleksi Cetak",
        path: "/koleksi-cetak"
      },
      {
        title: "Koleksi Elektronik",
        path: "/koleksi-elektronik"
      },
      {
        title: "Fasilitas Lainnya",
        path: "/fasilitas-lainnya"
      }
    ]
  },
  {
    title: "Layanan",
    path: null,
    submenus: [
      {
        title: "Pelayanan Sirkulasi",
        path: "/pelayanan-sirkulasi"
      },
      {
        title: "Peminjaman Bahan Pustaka",
        path: "/peminjaman"
      },
      {
        title: "Surat Bebas Perpustakaan",
        path: "/sbp"
      }
    ]
  },
  {
    title: "Tata Tertib",
    path: "/tata-tertib"
  },
  {
    title: "Struktur Organisasi",
    path: "/str-org"
  }
];

const RightSideBarTentangKami = (props) => {
  return <Box sx={{ display: { xs: "none", md: "block" } }}>
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{ height: "62px", backgroundColor: color.primary }}
    >
      <Typography
        sx={{
          textAlign: "center",
          color: color.light_white,
          fontSize: 24
        }}
      >
        Tentang Kami
      </Typography>
    </Stack>

    {menus.map((menu, key_menu) => (
      <Box
        key={key_menu}
        sx={
          props["menu-is-active"] === menu.title
            ? {
              borderLeft: "5px solid #0077B6",
              boxSizing: "border-box"
            }
            : {}
        }
      >
        <Stack
          key={key_menu}
          href={menu.path ? menu.path : undefined}
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          component={menu.path ? Link : 'div'}
          sx={
            props["menu-is-active"] === menu.title
              ? {
                color: color.primary,
                backgroundColor: color["primary-30p"],
                height: "56px",
                paddingX: "18px",
                textDecoration: 'none'
              }
              : {
                color: "inherit",
                textDecoration: 'inherit',
                backgroundColor: "white",
                height: "56px",
                paddingX: "18px",
                ":hover": {
                  cursor: "pointer",
                  backgroundColor: color["primary-30p"],
                  color: color.primary
                }
              }
          }
        >
          <Typography>{menu.title}</Typography>
          {menu.submenus &&
            <ExpandMoreIcon />}
        </Stack>
        {menu.submenus && menu.submenus.map((submenu, key_submenu) => (
          <Stack
            key={key_submenu}
            href={submenu.path}
            direction="row"
            alignItems="center"
            component={submenu.path ? Link : 'div'}
            sx={
              props["submenu-is-active"] === submenu.title
                ? {
                  height: "56px",
                  backgroundColor: color["primary-30p"],
                  color: color.primary,
                  paddingX: "36px",
                  textDecoration: 'none'
                }
                : {
                  color: "inherit",
                  textDecoration: 'inherit',
                  height: "56px",
                  backgroundColor: "white",
                  paddingX: "36px",
                  ":hover": {
                    cursor: "pointer",
                    backgroundColor: color["primary-30p"],
                    color: color.primary
                  },
                  ":visited": {
                    color: "inherit"
                  }
                }
            }
          >
            <Typography>{submenu.title}</Typography>
          </Stack>
        ))}
      </Box>
    ))}
  </Box>
};

export default RightSideBarTentangKami;
